<template>
	<div>
		<div v-if="!user.isAuth" class="login">
			<p>Для добавления комментария необходимо авторизоваться на сайте.</p>
			<login-form v-bind:user="user"></login-form>
			<a href="/registration">Регистрация</a>
		</div>

		<div v-if="user.isAuth" class="header">Добавить комментарий:</div>
		<div v-if="user.isAuth" class="comment-form">
			<img src="/images/avatar.png" alt="" class="avatar">
			<form method="post" @submit.prevent="send" class="form-group">
				<textarea rows="3" v-model="form.message" placeholder="Оставить комментарий"></textarea>
				<div class="sender">
					<i v-if="loader" class="fa fa-refresh fa-spin fa-1x fa-fw"></i>
					<button type="submit" class="btn btn-primary right">Добавить</button>
				</div>
			</form>
			<div class="rules">
				<h3>Запрещены:</h3>
				<ul>
					<li><p>спойлеры;</p></li>
					<li><p>оскорбления;</p></li>
					<li><p>призывы к ненависти;</p></li>
					<li><p>нарушение законов РФ.</p></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import LoginForm from './LoginForm.vue'

	export default {
		components: {
			'login-form': LoginForm
		},

		props: ['user', 'serial'],

		data: function () {
			return {
				loader: false,
				form: {
					message: '',
				}
			}
		},

		methods: {
			send: function () {
				if (this.form.message.length < 3) {
					alert('Очень короткое сообщение.');
					return false;
				}

				var request = $.ajax('/api/v1/serial/'+this.serial+'/comment', {
					'method': 'put',
					'data': {
						'comment': {
							message: this.form.message, 
						}
					},
					'dataType': 'json'
				});

				this.loader = true;

				request.then(function (data) {
					if (data.status === 'ok') {
						this.$emit('need-update');
						this.form.message = '';
					} else if (data.status === 'error') {
						alert('Произошла ошибка.');
					}

					this.loader = false;
				}.bind(this));
			}
		}
	}
</script>
